import { Component, HostListener, inject } from '@angular/core';
import { OverlayModule, ConnectedPosition } from '@angular/cdk/overlay';
import { ActionButtonService } from '../../services/action-button';

@Component({
  selector: 'app-action-button',
  imports: [OverlayModule],
  templateUrl: './action-button.html',
  styleUrl: './action-button.css',
})
export class ActionButton {
  private readonly actionMenuService = inject(ActionButtonService);

  readonly menuId = crypto.randomUUID();

  readonly positions: ConnectedPosition[] = [
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 4 },
    { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom', offsetY: -4 },
  ];

  get isOpen(): boolean {
    return this.actionMenuService.isOpen(this.menuId);
  }

  toggleMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.actionMenuService.toggle(this.menuId);
  }

  onMenuClick(event: MouseEvent): void {
    event.stopPropagation();

    const target = event.target as HTMLElement;

    if (target.closest('button')) {
      this.actionMenuService.close();
    }
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.actionMenuService.close();
  }
}
